var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookLogoBw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook-logo-bw_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 0c6.626 0 12 5.373 12 12 0 6.06-4.493 11.072-10.33 11.885l.003-.001V15.77h2.722l.512-3.522h-3.234V9.635c0-.625.508-1.132 1.133-1.132h2.101V5.457H13.69l-.016.002v-.002a3.594 3.594 0 0 0-3.594 3.594v3.198H7.098v3.521h2.982v8.076h-.002C4.364 22.927 0 17.973 0 12 0 5.373 5.374 0 12 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook-logo-bw_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgFacebookLogoBw;